export default __webpack_public_path__ + "alberta-arrow-down.ffe4b2654aa1874087b7.svg";